import { Address } from './address.model';


export class OrderInformation {
    public mobile?: string;
    public voucherReference?: string;

    constructor(public firstName?: string,
        public lastName?: string,
        public company?: string,
        public email?: string,
        public deliveryAddress?: Address,
        public invoiceAddress?: Address,
        public phone?: string,
        public customerOrderNumber?: string,
        public customerReference?: string,
        public customerOtherReference?: string,
        public comments?: string,
        public organisationId?: number) {
    }
}

export class ContactDetails {

    constructor(public firstName: string,
        public lastName: string,
        public phone: string,
        public email: string) {
    }
}

export class ReferenceDetails {

    constructor(public company: string,
        public customerOrderNumber: string,
        public customerReference: string,
        public customerOtherReference: string) {
    }
}

export const getBlankOrderInformation = () => {
    const address: Address = new Address('', '', '', '', '', '', 'New Zealand');
    const blankAddress: Address = { ...address, nzPostDpId: null };

    const newOrder = new OrderInformation('', '', '', '',
        blankAddress, blankAddress, '',
        '', '', '', '',
        null);
    newOrder.mobile = '';

    return newOrder;

};
